export default "__VITE_ASSET__DLn3WhFj__"